

// // import React, { useState, useEffect, useRef } from "react";

// // import Card from "@mui/material/Card";
// // import Popover from "@mui/material/Popover";
// // import { CircularProgress } from "@mui/material";

// // import SoftBox from "components/SoftBox";
// // import SoftTypography from "components/SoftTypography";
// // import SoftSelect from "components/SoftSelect";
// // import DataTable from "examples/Tables/DataTable";

// // import { getLeaveHistory } from "api/users";
// // import { useDropdownOptions } from "layouts/interviewSelected/hooks/useDropdownOptions";
// // import UserFilters from "layouts/interviewSelected/components/useFilters";

// // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// // import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
// // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // import dayjs from "dayjs";

// // /* ---------------- DEBOUNCE ---------------- */
// // const useDebounce = (value, delay = 500) => {
// //   const [debounced, setDebounced] = useState(value);

// //   useEffect(() => {
// //     const t = setTimeout(() => setDebounced(value), delay);
// //     return () => clearTimeout(t);
// //   }, [value, delay]);

// //   return debounced;
// // };

// // /* ---------------- CLEAN PARAMS (SAFE) ---------------- */
// // const cleanParams = (obj) => {
// //   const p = {};
// //   Object.keys(obj).forEach((k) => {
// //     const v = obj[k];
// //     if (
// //       v !== "" &&
// //       v !== "all" &&
// //       v !== null &&
// //       v !== undefined &&
// //       typeof v !== "object" // 🔐 VERY IMPORTANT
// //     ) {
// //       p[k] = v;
// //     }
// //   });
// //   return p;
// // };

// // function LeaveHistory() {
// //   const [leaveData, setLeaveData] = useState([]);
// //   const [pageLoading, setPageLoading] = useState(true);
// //   const [tableLoading, setTableLoading] = useState(false);

// //   /* ---------------- FILTER STATE (API SAFE) ---------------- */
// //   const [filters, setFilters] = useState({
// //     branch_id: "",
// //     shift_id: "",
// //     department_id: "",
// //     designation_id: "",
// //     role: "",
// //     status: "all",
// //     from: "",
// //     to: "",
// //     leave_policy_id: "",
// //   });

// //   const [searchTerm, setSearchTerm] = useState("");
// //   const debouncedSearch = useDebounce(searchTerm);

// //   const { dropdownOptions, fetchShiftsForBranch } = useDropdownOptions();

// //   /* ---------------- CALENDAR STATE (UI ONLY) ---------------- */
// //   const [fromAnchor, setFromAnchor] = useState(null);
// //   const [toAnchor, setToAnchor] = useState(null);

// //   /* ---------------- API CALL CONTROL ---------------- */
// //   const lastQueryRef = useRef("");

// //   /* ---------------- FETCH DATA ---------------- */
// //   const fetchLeaveRequests = async (initial = false) => {
// //     const params = cleanParams({
// //       ...filters,
// //       q: debouncedSearch,
// //     });

// //     const queryKey = JSON.stringify(params);

// //     if (!initial && lastQueryRef.current === queryKey) return;
// //     lastQueryRef.current = queryKey;

// //     try {
// //       initial ? setPageLoading(true) : setTableLoading(true);
// //       const res = await getLeaveHistory(params);
// //       setLeaveData(res?.data?.data || res?.data || []);
// //     } finally {
// //       setPageLoading(false);
// //       setTableLoading(false);
// //     }
// //   };

// //   /* ---------------- INITIAL LOAD ---------------- */
// //   useEffect(() => {
// //     fetchLeaveRequests(true);
// //   }, []);

// //   /* ---------------- FILTER CHANGE ---------------- */
// //   useEffect(() => {
// //     fetchLeaveRequests(false);
// //   }, [filters, debouncedSearch]);

// //   /* ---------------- FILTER HANDLER (SAFE) ---------------- */
// //   const handleFilterChange = (key, value) => {
// //     // ⛔ UI ONLY EVENTS
// //     if (key === "__open_from__") {
// //       setFromAnchor(value);
// //       return;
// //     }
// //     if (key === "__open_to__") {
// //       setToAnchor(value);
// //       return;
// //     }

// //     setFilters((prev) =>
// //       prev[key] === value ? prev : { ...prev, [key]: value }
// //     );
// //   };

// //   /* ---------------- HELPERS ---------------- */
// //   const formatDate = (d) => (d ? dayjs(d).format("DD-MMM-YYYY") : "N/A");
// //   const getStatusColor = (s) =>
// //     s === "approved" ? "success" : s === "pending" ? "warning" : "error";

// //   /* ---------------- TABLE ---------------- */
// //   const columns = [
// //     { Header: "Leave Type", accessor: "leave_type" },
// //     { Header: "Requester", accessor: "requester" },
// //     { Header: "From Date", accessor: "from_date" },
// //     { Header: "To Date", accessor: "to_date" },
// //     { Header: "Days", accessor: "days" },
// //     { Header: "Reason", accessor: "reason" },
// //     { Header: "Status", accessor: "status" },
// //     { Header: "Applied On", accessor: "applied_on" },
// //   ];

// //   const rows = leaveData.map((r) => ({
// //     leave_type: r.leave_policy?.leave_name || "N/A",
// //     requester: (
// //       <SoftBox>
// //         <SoftTypography variant="h6">{r.user?.name}</SoftTypography>
// //         <SoftTypography variant="caption">{r.user?.email}</SoftTypography>
// //       </SoftBox>
// //     ),
// //     from_date: formatDate(r.from_date),
// //     to_date: formatDate(r.to_date),
// //     days: r.days,
// //     reason: r.reason || "-",
// //     status: (
// //       <SoftTypography variant="h6" color={getStatusColor(r.status)} fontWeight="bold">
// //         {r.status}
// //       </SoftTypography>
// //     ),
// //     applied_on: formatDate(r.created_at),
// //   }));

// //   if (pageLoading) {
// //     return (
// //       <SoftBox p={3} textAlign="center">
// //         <CircularProgress />
// //       </SoftBox>
// //     );
// //   }

// //   return (
// //     <Card>
// //       <SoftBox p={3}>
// //         {/* ✅ ALL FILTERS (SECOND ROW INCLUDED INSIDE) */}
// //         <UserFilters
// //           filters={filters}
// //           onFilterChange={handleFilterChange}
// //           searchTerm={searchTerm}
// //           onSearchChange={setSearchTerm}
// //           dropdownOptions={dropdownOptions}
// //           fetchShiftsForBranch={fetchShiftsForBranch}
// //           showHistoryFilters
// //         />

// //         <SoftTypography variant="h6" mt={3} mb={2} color="text">
// //           Leave History ({rows.length})
// //         </SoftTypography>

// //         {tableLoading ? (
// //           <SoftBox textAlign="center" py={4}>
// //             <CircularProgress />
// //           </SoftBox>
// //         ) : (
// //           <DataTable
// //             table={{ columns, rows }}
// //             entriesPerPage={false}
// //             canSearch={false}
// //             showTotalEntries
// //           />
// //         )}
// //       </SoftBox>

// //       {/* FROM DATE CALENDAR */}
// //       <Popover
// //         open={Boolean(fromAnchor)}
// //         anchorEl={fromAnchor}
// //         onClose={() => setFromAnchor(null)}
// //       >
// //         <LocalizationProvider dateAdapter={AdapterDayjs}>
// //           <DateCalendar
// //             onChange={(d) => {
// //               handleFilterChange("from", d.format("YYYY-MM-DD"));
// //               setFromAnchor(null);
// //             }}
// //           />
// //         </LocalizationProvider>
// //       </Popover>

// //       {/* TO DATE CALENDAR */}
// //       <Popover
// //         open={Boolean(toAnchor)}
// //         anchorEl={toAnchor}
// //         onClose={() => setToAnchor(null)}
// //       >
// //         <LocalizationProvider dateAdapter={AdapterDayjs}>
// //           <DateCalendar
// //             onChange={(d) => {
// //               handleFilterChange("to", d.format("YYYY-MM-DD"));
// //               setToAnchor(null);
// //             }}
// //           />
// //         </LocalizationProvider>
// //       </Popover>
// //     </Card>
// //   );
// // }

// // export default LeaveHistory;


// import React, { useState, useEffect, useRef } from "react";

// import Card from "@mui/material/Card";
// import Popover from "@mui/material/Popover";
// import { CircularProgress } from "@mui/material";

// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import SoftSelect from "components/SoftSelect";
// import SoftPagination from "components/SoftPagination";
// import DataTable from "examples/Tables/DataTable";

// import { getLeaveHistory } from "api/users";
// import { useDropdownOptions } from "layouts/interviewSelected/hooks/useDropdownOptions";
// import UserFilters from "layouts/interviewSelected/components/useFilters";

// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import { getLeaveStatusInfo } from "layouts/leavetracker/helper";
// import Icon from "@mui/material/Icon";
// /* ---------------- DEBOUNCE ---------------- */
// const useDebounce = (value, delay = 500) => {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// };

// /* ---------------- CLEAN PARAMS ---------------- */
// const cleanParams = (obj) => {
//   const p = {};
//   Object.keys(obj).forEach((k) => {
//     const v = obj[k];
//     if (
//       v !== "" &&
//       v !== "all" &&
//       v !== null &&
//       v !== undefined &&
//       typeof v !== "object"
//     ) {
//       p[k] = v;
//     }
//   });
//   return p;
// };

// function LeaveHistory() {
//   const [leaveData, setLeaveData] = useState([]);
//   const [pageLoading, setPageLoading] = useState(true);
//   const [tableLoading, setTableLoading] = useState(false);

//   /* 🔹 PAGINATION STATE (SAME PATTERN) */
//   const [pagination, setPagination] = useState({
//     current_page: 1,
//     per_page: 10,
//     last_page: 1,
//     total: 0,
//   });


//   console.log(pagination)
//   /* ---------------- FILTER STATE ---------------- */
//   const [filters, setFilters] = useState({
//     branch_id: "",
//     shift_id: "",
//     department_id: "",
//     designation_id: "",
//     role: "",
//     status: "all",
//     from: "",
//     to: "",
//     leave_policy_id: "",
//   });

//   const [searchTerm, setSearchTerm] = useState("");
//   const debouncedSearch = useDebounce(searchTerm);

//   const { dropdownOptions, fetchShiftsForBranch } = useDropdownOptions();

//   /* ---------------- CALENDAR STATE ---------------- */
//   const [fromAnchor, setFromAnchor] = useState(null);
//   const [toAnchor, setToAnchor] = useState(null);

//   const lastQueryRef = useRef("");

//   /* ---------------- FETCH DATA ---------------- */
//   const fetchLeaveRequests = async (initial = false) => {
//     const params = cleanParams({
//       ...filters,
//       q: debouncedSearch,
//       page: pagination.current_page,
//       per_page: pagination.per_page,
//     });

//     const queryKey = JSON.stringify(params);
//     if (!initial && lastQueryRef.current === queryKey) return;
//     lastQueryRef.current = queryKey;

//     try {
//       initial ? setPageLoading(true) : setTableLoading(true);

//       const res = await getLeaveHistory(params);

//       const data = res?.data?.data || res?.data || [];
//       setLeaveData(data);

//       /* 🔹 PAGINATION META */
//       if (res) {
//         setPagination((p) => ({
//           ...p,
//           current_page: res.current_page,
//           last_page: res.last_page,
//           total: res.total,
//           per_page: res.per_page,
//         }));
//       }
//     } finally {
//       setPageLoading(false);
//       setTableLoading(false);
//     }
//   };

//   /* ---------------- INITIAL LOAD ---------------- */
//   useEffect(() => {
//     fetchLeaveRequests(true);
//   }, []);

//   /* ---------------- FILTER / SEARCH / PAGE CHANGE ---------------- */
//   useEffect(() => {
//     fetchLeaveRequests(false);
//   }, [filters, debouncedSearch, pagination.current_page]);

//   /* ---------------- FILTER HANDLER ---------------- */
//   const handleFilterChange = (key, value) => {
//     if (key === "__open_from__") {
//       setFromAnchor(value);
//       return;
//     }
//     if (key === "__open_to__") {
//       setToAnchor(value);
//       return;
//     }

//     setFilters((prev) =>
//       prev[key] === value ? prev : { ...prev, [key]: value }
//     );

//     /* 🔹 RESET PAGE ON FILTER CHANGE */
//     setPagination((p) => ({ ...p, current_page: 1 }));
//   };

//   /* ---------------- HELPERS ---------------- */
//   const formatDate = (d) => (d ? dayjs(d).format("DD-MMM-YYYY") : "N/A");
//   const getStatusColor = (s) =>
//     s === "approved" ? "success" : s === "pending" ? "info" : "error";

//   /* ---------------- TABLE ---------------- */
//   const columns = [
//     { Header: "Leave Type", accessor: "leave_type" },
//     { Header: "Requester", accessor: "requester" },
//     { Header: "From Date", accessor: "from_date" },
//     { Header: "To Date", accessor: "to_date" },
//     { Header: "Days", accessor: "days" },
//     { Header: "Reason", accessor: "reason" },
//     { Header: "Status", accessor: "status" },
//     { Header: "Applied On", accessor: "applied_on" },
//   ];

//   const rows = leaveData.map((r) => ({
//     leave_type: r.leave_policy?.leave_name || "N/A",
//     requester: r.user?.name,
//     from_date: formatDate(r.from_date),
//     to_date: formatDate(r.to_date),
//     days: r.days,
//     reason: r.reason || "-",
//     status: (() => {
//       const statusInfo = getLeaveStatusInfo(r.status);

//       return (
//         <SoftBox display="flex" alignItems="center" gap={0.5}>
//           <Icon
//             sx={{
//               fontSize: "1rem",
//               color: (theme) => theme.palette[statusInfo.color].main,
//             }}
//           >
//             {statusInfo.icon}
//           </Icon>

//           <SoftTypography
//             variant="button"
//             fontWeight="medium"
//             color={statusInfo.color}
//             sx={{ textTransform: "capitalize", fontSize: "0.8rem" }}
//           >
//             {statusInfo.text}
//           </SoftTypography>
//         </SoftBox>
//       );
//     })(),
//     applied_on: formatDate(r.created_at),
//   }));

//   if (pageLoading) {
//     return (
//       <SoftBox p={3} textAlign="center">
//         <CircularProgress />
//       </SoftBox>
//     );
//   }

//   return (
//     <Card>
//       <SoftBox p={3}>
//         <UserFilters
//           filters={filters}
//           onFilterChange={handleFilterChange}
//           searchTerm={searchTerm}
//           onSearchChange={setSearchTerm}
//           dropdownOptions={dropdownOptions}
//           fetchShiftsForBranch={fetchShiftsForBranch}
//           showHistoryFilters
//         />

//         <SoftTypography variant="h6" mt={1} mb={0} color="text">
//           Leave History ({pagination.total})
//         </SoftTypography>

//         {tableLoading ? (
//           <SoftBox textAlign="center" py={4}>
//             <CircularProgress />
//           </SoftBox>
//         ) : (
//           <DataTable
//             table={{ columns, rows }}
//             entriesPerPage={false}
//             canSearch={false}
//             showTotalEntries
//           />
//         )}

//         {/* 🔹 PAGINATION */}
//         {pagination.last_page > 1 && (
//           <SoftBox mt={2} display="flex" justifyContent="center">
//             <SoftPagination variant="gradient" color="info">
//               {Array.from({ length: pagination.last_page }, (_, i) => (
//                 <SoftPagination
//                   key={i}
//                   item
//                   active={pagination.current_page === i + 1}
//                   onClick={() =>
//                     setPagination((p) => ({
//                       ...p,
//                       current_page: i + 1,
//                     }))
//                   }
//                 >
//                   {i + 1}
//                 </SoftPagination>
//               ))}
//             </SoftPagination>
//           </SoftBox>
//         )}
//       </SoftBox>

//       {/* FROM DATE CALENDAR */}
//       <Popover
//         open={Boolean(fromAnchor)}
//         anchorEl={fromAnchor}
//         onClose={() => setFromAnchor(null)}
//       >
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DateCalendar
//             onChange={(d) => {
//               handleFilterChange("from", d.format("YYYY-MM-DD"));
//               setFromAnchor(null);
//             }}
//           />
//         </LocalizationProvider>
//       </Popover>

//       {/* TO DATE CALENDAR */}
//       <Popover
//         open={Boolean(toAnchor)}
//         anchorEl={toAnchor}
//         onClose={() => setToAnchor(null)}
//       >
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DateCalendar
//             onChange={(d) => {
//               handleFilterChange("to", d.format("YYYY-MM-DD"));
//               setToAnchor(null);
//             }}
//           />
//         </LocalizationProvider>
//       </Popover>
//     </Card>
//   );
// }

// export default LeaveHistory;



import React, { useState, useEffect, useRef, useMemo } from "react";

import Card from "@mui/material/Card";
import Popover from "@mui/material/Popover";
import { CircularProgress } from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftPagination from "components/SoftPagination";
import DataTable from "examples/Tables/DataTable";

import { getLeaveHistory } from "api/users";
import { useDropdownOptions } from "layouts/interviewSelected/hooks/useDropdownOptions";
import UserFilters from "layouts/interviewSelected/components/useFilters";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { getLeaveStatusInfo } from "layouts/leavetracker/helper";
import Icon from "@mui/material/Icon";

/* ---------------- DEBOUNCE ---------------- */
const useDebounce = (value, delay = 500) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};

/* ---------------- CLEAN PARAMS ---------------- */
const cleanParams = (obj) => {
  const p = {};
  Object.keys(obj).forEach((k) => {
    const v = obj[k];
    if (
      v !== "" &&
      v !== "all" &&
      v !== null &&
      v !== undefined &&
      typeof v !== "object"
    ) {
      p[k] = v;
    }
  });
  return p;
};

function LeaveHistory() {
  const [leaveData, setLeaveData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  /* 🔹 PAGINATION STATE */
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    last_page: 1,
    total: 0,
  });

  /* ---------------- FILTER STATE ---------------- */
  const [filters, setFilters] = useState({
    branch_id: "",
    shift_id: "",
    department_id: "",
    designation_id: "",
    role: "",
    status: "all",
    from: "",
    to: "",
    leave_policy_id: "",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm);

  /* ✅ NEW – useDropdownOptions returns lazy‑loaded options and fetch functions */
  const {
    options: dropdownOptions,
    loading: dropdownLoading,
    fetchBranches,
    fetchShifts,
    fetchDepartments,
    fetchDesignations,
    fetchRoles,
  } = useDropdownOptions();

  /* ---------------- CALENDAR STATE ---------------- */
  const [fromAnchor, setFromAnchor] = useState(null);
  const [toAnchor, setToAnchor] = useState(null);

  const lastQueryRef = useRef("");

  /* ---------------- FETCH DATA ---------------- */
  const fetchLeaveRequests = async (initial = false) => {
    const params = cleanParams({
      ...filters,
      q: debouncedSearch,
      page: pagination.current_page,
      per_page: pagination.per_page,
    });

    const queryKey = JSON.stringify(params);
    if (!initial && lastQueryRef.current === queryKey) return;
    lastQueryRef.current = queryKey;

    try {
      initial ? setPageLoading(true) : setTableLoading(true);

      const res = await getLeaveHistory(params);

      const data = res?.data?.data || res?.data || [];
      setLeaveData(data);

      if (res) {
        setPagination((p) => ({
          ...p,
          current_page: res.current_page,
          last_page: res.last_page,
          total: res.total,
          per_page: res.per_page,
        }));
      }
    } finally {
      setPageLoading(false);
      setTableLoading(false);
    }
  };

  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    fetchLeaveRequests(true);
  }, []);

  /* ---------------- FILTER / SEARCH / PAGE CHANGE ---------------- */
  useEffect(() => {
    fetchLeaveRequests(false);
  }, [filters, debouncedSearch, pagination.current_page]);

  /* ---------------- FILTER HANDLER ---------------- */
  const handleFilterChange = (key, value) => {
    if (key === "__open_from__") {
      setFromAnchor(value);
      return;
    }
    if (key === "__open_to__") {
      setToAnchor(value);
      return;
    }

    setFilters((prev) =>
      prev[key] === value ? prev : { ...prev, [key]: value }
    );

    setPagination((p) => ({ ...p, current_page: 1 }));
  };

  /* ---------------- HELPERS ---------------- */
  const formatDate = (d) => (d ? dayjs(d).format("DD-MMM-YYYY") : "N/A");

  // 🔹 Reason formatter: 6 words ke baad cut + ...
  const formatReason = (text, maxWords = 6) => {
    if (!text) return "N/A";
    const words = text.split(" ");
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join(" ") + "...";
  };

  /* ---------------- TABLE ---------------- */
  const columns = useMemo(
    () => [
      { Header: "Leave Type", accessor: "leave_type" },
      { Header: "Requester", accessor: "requester" },
      { Header: "Approver", accessor: "approver" },
      { Header: "From Date", accessor: "from_date" },
      { Header: "To Date", accessor: "to_date" },
      { Header: "Days", accessor: "days" },
      { Header: "Reason", accessor: "reason" },
      { Header: "Status", accessor: "status" },
      { Header: "Applied On", accessor: "applied_on" },
    ],
    []
  );

  const getPaginationRange = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;
    const limit = 5;

    let start = Math.max(1, current - Math.floor(limit / 2));
    let end = start + limit - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - limit + 1);
    }

    const pages = [];

    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < total) {
      if (end < total - 1) pages.push("...");
      pages.push(total);
    }

    return pages;
  };

  const rows = useMemo(
    () =>
      leaveData.map((r) => ({
        leave_type: r.leave_policy?.leave_name || "N/A",
        // requester: r.user?.name,
        requester: `${r.user?.name || ""} ${r.user?.last_name || ""}`.trim(),
        approver: r.approver ? `${r.approver.name} ${r.approver.last_name || ""}`.trim() : "N/A",
        from_date: formatDate(r.from_date),
        to_date: formatDate(r.to_date),
        days: r.days,
        //reason: r.reason || "-",
        reason: (
          <SoftTypography
            variant="caption"
            sx={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              maxWidth: "200px",   // 👈 adjust if needed (180px / 220px)
              lineHeight: 1.4,
            }}
            title={r.reason || ""} // 👈 hover pe full text
          >
            {formatReason(r.reason, 6)}
          </SoftTypography>
        ),
        status: (() => {
          const statusInfo = getLeaveStatusInfo(r.status);
          return (
            <SoftBox display="flex" alignItems="center" gap={0.5}>
              <Icon
                sx={{
                  fontSize: "1rem",
                  color: (theme) => theme.palette[statusInfo.color].main,
                }}
              >
                {statusInfo.icon}
              </Icon>
              <SoftTypography
                variant="button"
                fontWeight="medium"
                color={statusInfo.color}
                sx={{ textTransform: "capitalize", fontSize: "0.8rem" }}
              >
                {statusInfo.text}
              </SoftTypography>
            </SoftBox>
          );
        })(),
        applied_on: formatDate(r.created_at),
      })),
    [leaveData]
  );

  if (pageLoading) {
    return (
      <SoftBox p={3} textAlign="center">
        <CircularProgress />
      </SoftBox>
    );
  }

  return (
    <Card>
      <SoftBox p={3}>
        {/* ✅ UPDATED FILTERS – with new props */}
        <UserFilters
          filters={filters}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          dropdownOptions={dropdownOptions}
          loading={dropdownLoading}
          fetchBranches={fetchBranches}
          fetchShifts={fetchShifts}
          fetchDepartments={fetchDepartments}
          fetchDesignations={fetchDesignations}
          fetchRoles={fetchRoles}
          showHistoryFilters={true}
          pageContext="LeaveTracker.Mydata.AllLeaveHistory"
        />

        <SoftTypography variant="h6" mt={1} mb={0} color="text">
          Leave History ({pagination.total})
        </SoftTypography>

        {tableLoading ? (
          <SoftBox textAlign="center" py={4}>
            <CircularProgress />
          </SoftBox>
        ) : (
          <DataTable
            table={{ columns, rows }}
            entriesPerPage={false}
            canSearch={false}
            showTotalEntries
          />
        )}

        {/* PAGINATION */}
        {pagination.last_page > 1 && (
          <SoftBox mt={2} display="flex" justifyContent="center">
            <SoftPagination variant="gradient" color="info">
              {/* {Array.from({ length: pagination.last_page }, (_, i) => (
                <SoftPagination
                  key={i}
                  item
                  active={pagination.current_page === i + 1}
                  onClick={() =>
                    setPagination((p) => ({
                      ...p,
                      current_page: i + 1,
                    }))
                  }
                >
                  {i + 1}
                </SoftPagination>
              ))} */}



              {/* FIRST */}
              <SoftPagination
                item
                disabled={pagination.current_page === 1}
                onClick={() => {
                  setPagination((p) => ({
                    ...p,
                    current_page: 1,
                  }));
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                «
              </SoftPagination>

              {/* PREV */}
              <SoftPagination
                item
                disabled={pagination.current_page === 1}
                onClick={() => {
                  setPagination((p) => ({
                    ...p,
                    current_page: p.current_page - 1,
                  }));
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                ‹
              </SoftPagination>

              {/* PAGE NUMBERS */}
              {getPaginationRange().map((item, i) => {
                if (item === "...") {
                  return (
                    <SoftPagination key={i} item disabled>
                      ...
                    </SoftPagination>
                  );
                }

                return (
                  <SoftPagination
                    key={i}
                    item
                    active={pagination.current_page === item}
                    onClick={() => {
                      setPagination((p) => ({
                        ...p,
                        current_page: item,
                      }));
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    {item}
                  </SoftPagination>
                );
              })}

              {/* NEXT */}
              <SoftPagination
                item
                disabled={pagination.current_page === pagination.last_page}
                onClick={() => {
                  setPagination((p) => ({
                    ...p,
                    current_page: p.current_page + 1,
                  }));
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                ›
              </SoftPagination>

              {/* LAST */}
              <SoftPagination
                item
                disabled={pagination.current_page === pagination.last_page}
                onClick={() => {
                  setPagination((p) => ({
                    ...p,
                    current_page: pagination.last_page,
                  }));
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                »
              </SoftPagination>


            </SoftPagination>
          </SoftBox>
        )}
      </SoftBox>

      {/* FROM DATE CALENDAR */}
      <Popover
        open={Boolean(fromAnchor)}
        anchorEl={fromAnchor}
        onClose={() => setFromAnchor(null)}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            onChange={(d) => {
              handleFilterChange("from", d.format("YYYY-MM-DD"));
              setFromAnchor(null);
            }}
          />
        </LocalizationProvider>
      </Popover>

      {/* TO DATE CALENDAR */}
      <Popover
        open={Boolean(toAnchor)}
        anchorEl={toAnchor}
        onClose={() => setToAnchor(null)}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            onChange={(d) => {
              handleFilterChange("to", d.format("YYYY-MM-DD"));
              setToAnchor(null);
            }}
          />
        </LocalizationProvider>
      </Popover>
    </Card>
  );
}

export default LeaveHistory;
